// Name: Permissions Service Custom Render Components 

export const ORGANIZATION_CUSTOM_RENDER_COMPONENTS = {};
export const ORGANIZATION_RESOURCE_PERMISSION_RULE_CUSTOM_RENDER_COMPONENTS = {};
export const PERMISSIONS_ORGANIZATION_SETTINGS_CUSTOM_RENDER_COMPONENTS = {};
export const PERMISSION_ENTRY_CUSTOM_RENDER_COMPONENTS = {};
export const PERMISSION_LOG_ENTRY_CUSTOM_RENDER_COMPONENTS = {};
export const RESOURCE_PERMISSION_CUSTOM_RENDER_COMPONENTS = {};
